export const tree = {
  root: {
    background: "{content.background}",
    color: "{content.color}",
    padding: "0",
    gap: "{gap.4}",
    indent: "{padding.16}",
    transitionDuration: "{transition.duration}",
  },
  node: {
    padding: "{padding.6} {padding.10}",
    borderRadius: "{content.border.radius}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{content.hover.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{content.hover.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}",
    },
    gap: "{gap.6}",
  },
  nodeIcon: {
    color: "{content.color}",
    hoverColor: "{primary.support}",
    selectedColor: "{primary.default}",
  },
  nodeToggleButton: {
    borderRadius: "50%",
    size: "{icon.size}",
    hoverBackground: "transparent",
    selectedHoverBackground: "transparent",
    color: "{content.color}",
    hoverColor: "{primary.support}",
    selectedHoverColor: "{primary.default}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  // loadingIcon: {
  //   size: "2rem",
  // },
  filter: {
    margin: "0 0 {padding.16} 0",
  },
  extend: {
    ui: {
      header: {
        borderWidth: "0 0 {border.width.1} 0",
        borderColor: "{surface.border}",
        padding: "{padding.16}",
      },
      footer: {
        borderWidth: "{border.width.1} 0 0 0",
        borderColor: "{surface.border}",
        padding: "{padding.16}",
      },
      main: {
        padding: "{padding.16}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-tree {
      display: flex;
      flex-direction: column;
    }

    .p-tree > *:has(~ .p-tree-root),
    .p-tree > *:has(~ .p-tree-empty-message) {
      border-color: ${dt("tree.ui.header.border.color")};
      border-width: ${dt("tree.ui.header.border.width")};
      padding: ${dt("tree.ui.header.padding")};
    }

    .p-tree > .p-tree-root ~ *,
    .p-tree > .p-tree-empty-message ~ * {
      border-color: ${dt("tree.ui.footer.border.color")};
      border-width: ${dt("tree.ui.footer.border.width")};
      padding: ${dt("tree.ui.footer.padding")};
    }

    .p-tree > .p-tree-root,
    .p-tree > .p-tree-empty-message {
      padding: ${dt("tree.ui.main.padding")};
    }

    .p-tree-node-label {
      width: 100%;
    }

    /* Process model tree: border bottom on the entire process-level treenode row */
    .p-tree-node-content:has(.pm-font-bold) {
      border-bottom: 1px solid ${dt("surface.border")};
      padding-bottom: 0.25rem;
    }

    /* Process model tree: bigger/weightier labels for process, area, phase */
    .p-tree-node-label:has(.pm-font-bold) { font-weight: 600; font-size: 1.125rem; }
    .p-tree-node-label:has(.pm-font-semibold),
    .p-tree-node-label:has(.pm-font-medium) { font-weight: 600; font-size: 1rem; }
  `,
};
